// frontend-react/src/pages/AdminPanel.js

import React, { useState, useEffect } from 'react';
import * as api from '../api/api';
import './AdminPanel.css';
import './Pages.css';
import { FiUsers, FiChevronDown, FiChevronUp, FiTrash2, FiEdit, FiPlus, FiSave, FiX } from 'react-icons/fi';
import toast from 'react-hot-toast';

// UserDetails component παραμένει το ίδιο, δεν χρειάζεται αλλαγή.
const UserDetails = ({ userId }) => {
    // ... (Ο κώδικας αυτού του component παραμένει ακριβώς ο ίδιος με πριν) ...
    const [data, setData] = useState({ trades: [], positions: [], watchlist: [] });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const [tradesRes, positionsRes, watchlistRes] = await Promise.all([
                    api.adminGetUserTrades(userId),
                    api.adminGetUserPositions(userId),
                    api.adminGetUserWatchlist(userId)
                ]);
                setData({ trades: tradesRes.data, positions: positionsRes.data, watchlist: watchlistRes.data });
            } catch(error) {
                console.error(`Failed to fetch data for user ${userId}`, error);
            } finally {
                setLoading(false);
            }
        };
        fetchUserData();
    }, [userId]);

    if (loading) return <div className="user-details-expanded"><p>Loading user data...</p></div>;

    return (
        <div className="user-details-expanded">
            <div className="details-grid">
                <div>
                    <h4>Live Positions</h4>
                    {data.positions.length > 0 ? (
                        <table className="data-table compact">
                            <thead><tr><th>Ticker</th><th>Qty</th><th>P/L</th></tr></thead>
                            <tbody>
                                {data.positions.map(p => (
                                    <tr key={p.ticker}>
                                        <td>{p.ticker}</td><td>{p.qty}</td><td className={p.unrealized_pl >= 0 ? 'positive' : 'negative'}>${p.unrealized_pl.toFixed(2)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : <p>No live positions.</p>}
                </div>
                <div>
                    <h4>Recent Trade History</h4>
                    {data.trades.length > 0 ? (
                         <table className="data-table compact">
                            <thead><tr><th>Ticker</th><th>P/L</th><th>Closed At</th></tr></thead>
                            <tbody>
                                {data.trades.slice(0, 5).map(t => (
                                    <tr key={t.id}>
                                        <td>{t.ticker}</td><td className={t.pnl >= 0 ? 'positive' : 'negative'}>${t.pnl?.toFixed(2)}</td><td>{new Date(t.closed_at).toLocaleDateString()}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : <p>No trade history.</p>}
                </div>
                 <div>
                    <h4>Watchlist</h4>
                    {data.watchlist.length > 0 ? (
                         <table className="data-table compact">
                            <thead><tr><th>Ticker</th><th>Status</th></tr></thead>
                            <tbody>
                                {data.watchlist.map(w => (
                                    <tr key={w.id}>
                                        <td>{w.ticker}</td><td>{w.status}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : <p>Watchlist is empty.</p>}
                </div>
            </div>
        </div>
    );
};

// --- ΝΕΟ COMPONENT: ΦΟΡΜΑ ΕΠΕΞΕΡΓΑΣΙΑΣ/ΔΗΜΙΟΥΡΓΙΑΣ ΧΡΗΣΤΗ ---
const UserForm = ({ user, onSave, onCancel }) => {
    const [formData, setFormData] = useState({
        username: user?.username || '',
        email: user?.email || '',
        password: '',
        role: user?.role || 'user',
        subscription_status: user?.subscription_status || 'incomplete',
        private_beta_access: Boolean(user?.private_beta_access),
    });

    const isEditing = !!user;

    const handleChange = (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        setFormData({ ...formData, [e.target.name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!isEditing && !formData.password) {
            toast.error("Password is required for new users.");
            return;
        }
        onSave(formData);
    };

    return (
        <div className="card user-card" style={{marginTop: '1rem', border: '1px solid var(--accent-primary)'}}>
            <form onSubmit={handleSubmit}>
                <h3 style={{marginTop: 0}}>{isEditing ? `Editing ${user.username}` : 'Create New User'}</h3>
                <div className='details-grid'>
                    <div className="form-group">
                        <label>Username</label>
                        <input type="text" name="username" value={formData.username} onChange={handleChange} required disabled={isEditing} />
                    </div>
                    <div className="form-group">
                        <label>Email</label>
                        <input type="email" name="email" value={formData.email} onChange={handleChange} required />
                    </div>
                     {!isEditing && (
                        <div className="form-group">
                            <label>Password</label>
                            <input type="password" name="password" value={formData.password} onChange={handleChange} required />
                        </div>
                    )}
                    <div className="form-group">
                        <label>Role</label>
                        <select name="role" value={formData.role} onChange={handleChange}>
                            <option value="user">User</option>
                            <option value="admin">Admin</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <label>Subscription Status</label>
                         <select name="subscription_status" value={formData.subscription_status} onChange={handleChange}>
                            <option value="active">Active</option>
                            <option value="trialing">Trialing</option>
                            <option value="canceled">Canceled</option>
                            <option value="incomplete">Incomplete</option>
                            <option value="past_due">Past Due</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <label style={{display:'flex', gap:'.55rem', alignItems:'center'}}>
                            <input type="checkbox" name="private_beta_access" checked={formData.private_beta_access} onChange={handleChange} />
                            Private Beta Scanner Access (free, invite-only)
                        </label>
                    </div>
                </div>
                <div className="user-actions" style={{marginTop: '1.5rem'}}>
                    <button type="button" className="control-button small" onClick={onCancel}><FiX/> Cancel</button>
                    <button type="submit" className="control-button small"><FiSave/> Save User</button>
                </div>
            </form>
        </div>
    );
};


const AdminPanel = () => {
    const [users, setUsers] = useState([]);
    const [expandedUser, setExpandedUser] = useState(null);
    const [editingUser, setEditingUser] = useState(null); // null, a user object, or 'new'
    
    const fetchUsers = async () => {
        try {
            const response = await api.adminGetAllUsers();
            setUsers(response.data);
        } catch (error) { toast.error("Failed to fetch users"); }
    };

    useEffect(() => { fetchUsers(); }, []);
    
    const handleDeleteUser = async (userId, username) => {
        if (window.confirm(`Are you sure you want to PERMANENTLY DELETE user '${username}'?`)) {
            const promise = api.adminDeleteUser(userId);
            toast.promise(promise, {
                loading: `Deleting ${username}...`,
                success: () => { fetchUsers(); return 'User deleted.'; },
                error: (err) => err.response?.data?.detail || 'Failed to delete user.'
            });
        }
    };

    const handleSaveUser = async (formData) => {
        const isEditing = editingUser !== 'new';
        const promise = isEditing 
            ? api.adminUpdateUser(editingUser.id, formData)
            : api.adminCreateUser(formData);
        
        toast.promise(promise, {
            loading: `${isEditing ? 'Updating' : 'Creating'} user...`,
            success: () => {
                setEditingUser(null);
                fetchUsers();
                return `User ${isEditing ? 'updated' : 'created'} successfully!`;
            },
            error: (err) => err.response?.data?.detail || 'Operation failed.'
        });
    };

    return (
        <div>
            <h1>Admin Panel</h1>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <h2><FiUsers className="icon"/> User Management</h2>
                <button className="control-button" onClick={() => setEditingUser('new')}><FiPlus/> Create User</button>
            </div>

            {editingUser && (
                <UserForm 
                    user={editingUser === 'new' ? null : editingUser}
                    onSave={handleSaveUser}
                    onCancel={() => setEditingUser(null)}
                />
            )}

            <div className="user-list" style={{marginTop: '2rem'}}>
                {users.map(user => (
                    <div key={user.id} className="card user-card">
                        <div className="user-summary">
                            <div className="user-info" onClick={() => setExpandedUser(expandedUser === user.id ? null : user.id)}>
                                <strong className="username">{user.username}</strong>
                                <span className="email">{user.email}</span>
                            </div>
                            <div className="user-tags">
                                <span className="tag-role">{user.role}</span>
                                {user.private_beta_access && <span className="tag-sub">PRIVATE BETA</span>}
                                <span className="tag-sub">{user.subscription_status || 'N/A'}</span>
                            </div>
                            <div className="user-actions">
                                <button className="control-button small" onClick={() => setEditingUser(user)}><FiEdit/> Edit</button>
                                <button className="control-button small danger" onClick={() => handleDeleteUser(user.id, user.username)}>
                                    <FiTrash2/> Delete
                                </button>
                                <button className="icon-button" onClick={() => setExpandedUser(expandedUser === user.id ? null : user.id)}>
                                    {expandedUser === user.id ? <FiChevronUp /> : <FiChevronDown />}
                                </button>
                            </div>
                        </div>
                        {expandedUser === user.id && <UserDetails userId={user.id} />}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AdminPanel;